import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import CSVExport from '@/components/CSVExport'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Add from '@/components/Add'
import AddCompany from '@/components/AddCompany'
import AddDevice from '@/components/AddDevice'
import Edit from '@/components/Edit'
import New from '@/components/New'
import Password from '@/components/Password'
import Twilio from '@/components/Twilio'
import User from '@/components/User'
import ViewDID from '@/components/ViewDID'
import Report from '@/components/Report'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import firebase from 'firebase'


Vue.use(Vuetify)
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/csvexport',
      name: 'csvexport',
      component: CSVExport,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add',
      name: 'add',
      component: Add,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/addcompany',
      name: 'addcompany',
      component: AddCompany,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/adddevice',
      name: 'adddevice',
      component: AddDevice,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/edit/:did',
      name: 'edit',
      component: Edit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/twilio',
      name: 'twilio',
      component: Twilio,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user/:user',
      name: 'user',
      component: User,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/new/',
      name: 'new',
      component: New,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/password/',
      name: 'password',
      component: Password,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:did',
      name: 'viewdid',
      component: ViewDID,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

// Nav Guards
router.beforeEach((to, from, next) => {
  // Check for requiredAuth guard
  if(to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NOT logged in
    if(!firebase.auth().currentUser){
      // Go to login
      next({
        path: 'login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
   } else if(to.matched.some(record => record.meta.requiresGuest)) {
     // Check if logged in
    if(firebase.auth().currentUser){
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
   } else {
     // Proceed to route
     next();
   }
});

export default router;

// Nav Guards



// WEBPACK FOOTER //
// ./src/router/index.js